import React from "react";
import {useTranslation} from "react-i18next";
import {Section} from "../../../common/section";
import {Badges} from "../../../common/badges";
import GatsbyImage from "gatsby-image";
import {graphql, useStaticQuery} from "gatsby";

export const Benefits: React.FC = () => {
  const {t} = useTranslation();

  const items = [1, 2, 3, 4];

  const data = useStaticQuery(graphql`
  query {
  benefits: file(relativePath: {eq: "hyperion/Hyperion-Office-normal.jpg"}) { ...squareImage } 
  }`)

  return (
    <Section className="benefits">
      <div className="intro-text">
        <h2>{t('products.hyperion.office.benefits.heading')}</h2>
        <div className="text">
          <p>{t('products.hyperion.office.benefits.description')}</p>
        </div>
      </div>
      <div>
        <Badges/>
      </div>
      <div className="advantages">

        <div className="image">
          <GatsbyImage
            style={{height: "100%", width: "100%"}}
            fluid={data.benefits.childImageSharp.fluid}
          />
        </div>

        <div className="text">
          <h2>{t('products.hyperion.office.benefits.subsection.heading')}</h2>
          <p>{t('products.hyperion.office.benefits.subsection.description')}</p>
          <ul>
            {
              items.map((item, index) => {
                return (
                  <li key={index} className={t(`products.hyperion.office.benefits.items.${index}.class`)}>
                    <h4>{t(`products.hyperion.office.benefits.items.${index}.heading`)}</h4>
                    <p className="small">{t(`products.hyperion.office.benefits.items.${index}.description`)}</p>
                  </li>
                )
              })
            }
          </ul>
        </div>
      </div>
    </Section>
  )
}
